import React from 'react';

/**
 * Statements separated by hairlines — the "reading the curve" style side panels. The last item is
 * rendered muted and rule-less, which is where the design puts its caveat line.
 */
const RuleList = ({ items, mutedLast = false }) => {
  const rows = items.filter(Boolean);

  return (
    <div className='grid gap-ds-4 text-ts-md text-gray-800'>
      {rows.map((item, index) => {
        const isLast = index === rows.length - 1;
        const muted = mutedLast && isLast;

        return (
          <div
            key={index}
            className={`${isLast ? '' : 'border-b border-gray-300 pb-ds-4'} ${
              muted ? 'text-sm text-gray-600' : ''
            }`.trim()}
          >
            {item}
          </div>
        );
      })}
    </div>
  );
};

export default RuleList;
